import React from 'react';

export const SEOContent = () => {
  return (
    <section className="py-10 bg-neutral-950 relative">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent"></div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-b from-neutral-900 to-neutral-950 border border-amber-500/20 rounded-2xl p-8 space-y-6">
          <h2 className="text-3xl font-bold text-amber-400 mb-6" style={{fontFamily: 'Cormorant Garamond, serif'}}>
            Marabout Africain à Genève : Le Meilleur Voyant Médium pour un Retour Affectif Rapide
          </h2>
          
          <div className="space-y-6 text-sm leading-relaxed">
            <p className="text-amber-100/70">
              <strong className="text-amber-400">Marabout Genève</strong> : Vous recherchez un <strong className="text-amber-400">marabout africain sérieux et efficace à Genève</strong> ? 
              Notre cabinet de marabout est le <strong className="text-amber-400">n°1 du retour affectif rapide à Genève</strong> et dans toute la Suisse romande. 
              Avec plus de <strong>30 ans d'expérience</strong> dans les arts divinatoires, la voyance et la spiritualité africaine, 
              notre <strong className="text-amber-400">grand marabout africain</strong> est reconnu comme le <strong className="text-amber-400">meilleur voyant médium de Genève</strong>.
            </p>

            <h3 className="text-2xl font-semibold text-amber-400 mt-6" style={{fontFamily: 'Cormorant Garamond, serif'}}>
              Retour Affectif Rapide à Genève : Résultats Garantis en 3 à 7 Jours
            </h3>
            <p className="text-amber-100/60">
              Le <strong className="text-amber-400">retour affectif</strong> est notre spécialité principale. Notre <strong className="text-amber-400">marabout à Genève</strong> utilise des 
              <strong> rituels ancestraux puissants</strong> pour <strong className="text-amber-400">faire revenir l'être aimé en 3 à 7 jours maximum</strong>. 
              Que vous cherchiez un <strong>retour affectif rapide</strong>, une <strong>réconciliation amoureuse</strong> ou le 
              <strong> retour de l'être cher</strong>, notre <strong className="text-amber-400">marabout sérieux</strong> a déjà aidé des <strong>centaines de couples à Genève</strong>, 
              Lausanne, et dans toute la Suisse.
            </p>

            <h3 className="text-2xl font-semibold text-amber-400 mt-6" style={{fontFamily: 'Cormorant Garamond, serif'}}>
              Voyant Médium Sérieux et Reconnu à Genève
            </h3>
            <p className="text-amber-100/60">
              En tant que <strong className="text-amber-400">voyant médium reconnu à Genève</strong>, notre marabout possède un don exceptionnel de clairvoyance 
              hérité de ses ancêtres d'Afrique de l'Ouest. Ses <strong>consultations de voyance</strong> sont réputées pour leur <strong>précision remarquable</strong>. 
              Que vous consultiez un <strong className="text-amber-400">voyant à Genève</strong> ou un <strong className="text-amber-400">médium à Genève</strong>, 
              vous bénéficiez de la même qualité de guidance spirituelle, que ce soit en personne ou à distance.
            </p>

            <h3 className="text-2xl font-semibold text-amber-400 mt-6" style={{fontFamily: 'Cormorant Garamond, serif'}}>
              Désenvoûtement et Protection Spirituelle à Genève
            </h3>
            <p className="text-amber-100/60">
              Le <strong className="text-amber-400">désenvoûtement à Genève</strong> est un service essentiel. Notre <strong className="text-amber-400">marabout expert en désenvoûtement</strong> peut 
              identifier la source de vos problèmes et lever tout <strong>sort</strong> ou <strong>malédiction</strong>. 
              La <strong className="text-amber-400">protection spirituelle</strong> qu'il offre vous met à l'abri des forces négatives. 
              Que ce soit pour un <strong>désenvoûtement puissant</strong> ou une <strong>protection contre le mauvais oeil</strong>, 
              notre marabout africain à Genève est votre meilleur allié.
            </p>

            <h3 className="text-2xl font-semibold text-amber-400 mt-6" style={{fontFamily: 'Cormorant Garamond, serif'}}>
              Marabout à Genève : Pourquoi Nous Choisir ?
            </h3>
            <ul className="list-disc list-inside space-y-2 text-amber-100/60 ml-4">
              <li><strong className="text-amber-400">30 ans d'expérience</strong> dans la spiritualité africaine et les rituels ancestraux</li>
              <li><strong className="text-amber-400">Plus de 800 clients satisfaits</strong> à Genève, Lausanne et dans toute la Suisse</li>
              <li><strong className="text-amber-400">Note moyenne de 4.9/5</strong> basée sur des centaines d'avis vérifiés</li>
              <li><strong className="text-amber-400">Résultats garantis en 3 à 7 jours</strong> pour le retour affectif</li>
              <li><strong className="text-amber-400">Discrétion absolue</strong> et confidentialité garanties</li>
              <li><strong className="text-amber-400">Première consultation gratuite</strong> sans engagement</li>
              <li><strong className="text-amber-400">Disponible 7j/7 de 8h à 23h30</strong></li>
              <li><strong className="text-amber-400">Facilité de paiement</strong></li>
              <li><strong className="text-amber-400">Consultation en cabinet ou à distance</strong> dans toute la Suisse</li>
            </ul>

            <h3 className="text-2xl font-semibold text-amber-400 mt-6" style={{fontFamily: 'Cormorant Garamond, serif'}}>
              Zones d'Intervention : Marabout dans toute la Suisse
            </h3>
            <p className="text-amber-100/60">
              Notre <strong className="text-amber-400">grand marabout africain</strong> intervient dans toute la Suisse : 
              <strong className="text-amber-400"> Genève</strong>, <strong>Carouge</strong>, <strong>Meyrin</strong>, <strong>Vernier</strong>, <strong>Lancy</strong>, <strong>Onex</strong>, 
              <strong className="text-amber-400"> Lausanne</strong>, <strong>Montreux</strong>, <strong>Vevey</strong>, <strong>Nyon</strong>, <strong>Morges</strong>, 
              <strong className="text-amber-400"> Fribourg</strong>, <strong>Neuchâtel</strong>, <strong>Sion</strong>, <strong>Berne</strong>, <strong>Zürich</strong>, <strong>Bâle</strong>. 
              Que vous soyez dans le <strong>canton de Genève</strong>, le <strong>canton de Vaud</strong>, en <strong>Suisse romande</strong> ou 
              en <strong>Suisse alémanique</strong>, notre marabout se déplace ou travaille à distance.
            </p>

            <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-6 mt-8">
              <p className="text-center text-white font-semibold text-base">
                <strong className="text-amber-400 text-xl">+41 76 783 61 86</strong> . Consultation Gratuite . Disponible 7j/7 . Discrétion Absolue
              </p>
              <p className="text-center text-amber-200/50 text-sm mt-2">
                Marabout Genève | Voyant Genève | Médium Genève | Retour Affectif | Désenvoûtement | Marabout Africain | Voyant Médium Sérieux
              </p>
            </div>
          </div>
        </div>

        {/* Hidden SEO keyword anchors */}
        <div className="mt-8 text-center">
          <p className="text-xs text-amber-200/20 leading-relaxed">
            marabout geneve, marabout africain geneve, retour affectif geneve, voyant geneve, voyant medium geneve, 
            marabout serieux geneve, retour etre aime geneve, desenvoutement geneve, marabout suisse, marabout efficace geneve, 
            grand marabout geneve, meilleur marabout geneve, voyance geneve, medium geneve, guerisseur spirituel geneve, 
            marabout lausanne, marabout vaud, marabout suisse romande, protection spirituelle geneve, chance aux jeux geneve,
            marabout carouge, marabout vernier, marabout meyrin, marabout lancy, marabout nyon, marabout montreux,
            voyant africain geneve, medium africain geneve, retour affectif rapide, marabout puissant geneve,
            marabout reconnu geneve, marabout competent geneve, voyant serieux geneve, medium serieux geneve,
            marabout, voyant, medium, retour affectif, desenvoutement, protection spirituelle, guerisseur, magie blanche
          </p>
        </div>
      </div>
    </section>
  );
};
